export const SolanaLogo = ({ size = 22, className = "" }) => (
  <svg width={size} height={size * 0.88} viewBox="0 0 100 88" fill="none" className={className} aria-label="Solana">
    <defs>
      <linearGradient id="sol-grad" x1="0" y1="88" x2="100" y2="0" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#9945FF" />
        <stop offset="0.5" stopColor="#14F195" />
        <stop offset="1" stopColor="#00F0FF" />
      </linearGradient>
    </defs>
    <path
      fill="url(#sol-grad)"
      d="M16.4 64.6c.6-.6 1.4-.9 2.3-.9h79.6c1.4 0 2.1 1.7 1.1 2.7L83.6 82.1c-.6.6-1.4.9-2.3.9H1.7c-1.4 0-2.1-1.7-1.1-2.7L16.4 64.6zM16.4 1.9C17 1.3 17.8 1 18.7 1h79.6c1.4 0 2.1 1.7 1.1 2.7L83.6 19.4c-.6.6-1.4.9-2.3.9H1.7c-1.4 0-2.1-1.7-1.1-2.7L16.4 1.9zM83.6 33.1c-.6-.6-1.4-.9-2.3-.9H1.7c-1.4 0-2.1 1.7-1.1 2.7l15.8 15.7c.6.6 1.4.9 2.3.9h79.6c1.4 0 2.1-1.7 1.1-2.7L83.6 33.1z"
    />
  </svg>
);
